<div class="app">
  <credo-bank-navbar></credo-bank-navbar>
</div>
